/* Reservierung für Vorbestellungen (r193, Ms Adler 27.09 + 30.09, Felix ok 05.10.2026)
   ────────────────────────────────────────────────────────────────────
   On a pre-order size the customer reserves the piece for a store: store, name, e-mail and a
   Cloudflare Turnstile check. The partner portal sends a confirmation e-mail, and the reservation
   counts only after the click there (double opt-in). When the delivery arrives, the portal sends the
   piece to that store, and the store holds it for seven days.

   The portal decides everything else: whether reservations are open at all (enabled:false while its
   switch is off, test:true while it only takes test addresses), which stores take part, and the
   product data of the mail - it reads the shop itself and never trusts this page for it. Refusals
   come back with a code; the text for it is the shop's own (DE + EN), never the portal's German.

   Markup: snippets/preorder-reserve.liquid. Translations come from window.g26t, which returns them
   HTML-escaped (Shopify's t filter) - so they go into innerHTML, and every value read from the page
   or typed by the customer is escaped before it joins them. */
(function () {
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }

  // The store a customer is standing in (QR store mode) wins over the favourite store, as in the
  // availability modal (store-reserve.js) - both are page slugs, and the portal names each store's slug.
  function preferredStore() {
    var c = window.GoesslStoreMode && window.GoesslStoreMode.get();
    if (c && c.page) return String(c.page);
    try { return localStorage.getItem('goessl:favStore') || null; } catch (e) { return null; }
  }

  // One promise shared with store-reserve.js (today's Reservieren form), so the script never loads twice.
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!window.__g26TurnstileLoading) {
      window.__g26TurnstileLoading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = TURNSTILE_SRC;
        s.async = true;
        s.onload = function () { if (window.turnstile) resolve(window.turnstile); else reject(new Error('turnstile')); };
        s.onerror = function () { window.__g26TurnstileLoading = null; reject(new Error('turnstile')); };
        document.head.appendChild(s);
      });
    }
    return window.__g26TurnstileLoading;
  }

  // A refusal code from the portal -> the shop's own text. Literal window.g26t calls on purpose:
  // tools-i18n/gen-i18n.py finds the keys for the string bridge in theme.liquid only that way.
  function errorText(code) {
    switch (code) {
      case 'unavailable': return window.g26t('stores.preorder_reserve.error_unavailable', 'Diese Größe lässt sich gerade nicht im Geschäft reservieren.');
      case 'name': return window.g26t('stores.preorder_reserve.error_name', 'Bitte geben Sie Ihren Namen an.');
      case 'email': return window.g26t('stores.preorder_reserve.error_email', 'Bitte geben Sie eine gültige E-Mail-Adresse an.');
      case 'turnstile': return window.g26t('stores.preorder_reserve.error_turnstile', 'Die Sicherheitsprüfung hat nicht geklappt – bitte laden Sie die Seite neu.');
      case 'rate': return window.g26t('stores.preorder_reserve.error_rate', 'Zu viele Anfragen – bitte versuchen Sie es später noch einmal.');
      case 'store': return window.g26t('stores.preorder_reserve.error_store', 'Bitte wählen Sie ein Geschäft.');
      default: return window.g26t('stores.reserve.error_generic', 'Das hat leider nicht geklappt – bitte versuchen Sie es gleich noch einmal.');
    }
  }

  function init() {
    var modal = document.querySelector('[data-presv-modal]');
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-presv-open]'));
    var teasers = Array.prototype.slice.call(document.querySelectorAll('[data-presv-teaser]'));
    if (!modal || !openers.length) return;

    var base = (modal.getAttribute('data-endpoint') || 'https://partner.goessl.com').replace(/\/+$/, '');
    var lang = /^en/i.test(modal.getAttribute('data-lang') || '') ? 'en' : 'de';
    function q(sel) { return modal.querySelector(sel); }
    var form = q('[data-presv-form]'), intro = q('[data-presv-intro]'), ctxEl = q('[data-presv-ctx]');
    var okEl = q('[data-presv-ok]'), errEl = q('[data-presv-err]');
    var storeSel = q('[data-presv-store]'), nameEl = q('[data-presv-name]'), mailEl = q('[data-presv-email]');
    var submitBtn = q('[data-presv-submit]'), tsBox = q('[data-presv-turnstile]');
    // The product form the link sits in: its variant input is the size the customer chose.
    var productForm = openers[0].closest('form');
    var scope = (productForm && productForm.closest('.shopify-section')) || document;

    var config = null;          // the portal's answer: { sitekey, test, stores: [{ id, label, page }] }
    var token = '';
    var widget = null;
    var sending = false;

    function variantId() {
      var input = productForm && productForm.querySelector('[name="id"]');
      return input && input.value ? String(input.value) : '';
    }
    function selectedText(sel) {
      var el = scope.querySelector(sel);
      return el ? el.textContent.trim() : '';
    }

    // Ask the portal once whether reservations are open; only then does the link show. While the
    // portal takes test addresses only, the live shop never shows it - a preview theme does.
    fetch(base + '/api/public/reserve-stores', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.enabled || !j.sitekey || !Array.isArray(j.stores) || !j.stores.length) return;
        var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
        if (j.test && role === 'main') return;
        config = j;
        fillStores();
        openers.forEach(function (b) { b.removeAttribute('hidden'); });
        teasers.forEach(function (t) { t.removeAttribute('hidden'); });
      })
      .catch(function () { /* no portal, no link - the pre-order itself works as before */ });

    function fillStores() {
      var pref = preferredStore();
      storeSel.innerHTML = '<option value="">' + window.g26t('stores.preorder_reserve.store_placeholder', 'Geschäft wählen') + '</option>' +
        config.stores.map(function (s) {
          return '<option value="' + esc(s.id) + '"' + (pref && s.page === pref ? ' selected' : '') + '>' + esc(s.label) + '</option>';
        }).join('');
    }

    function fillContext() {
      var rows = [
        [window.g26t('stores.reserve.item', 'Artikel'), modal.getAttribute('data-product-title') || ''],
        [window.g26t('stores.reserve.color', 'Farbe'), selectedText('[data-selected-color]')],
        [window.g26t('products.size_fit.size', 'Größe'), selectedText('.goessl-product__size-btn.active')],
      ];
      ctxEl.innerHTML = rows.filter(function (r) { return r[1]; }).map(function (r) {
        return '<div class="g26-resv__ctx-row"><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>';
      }).join('');
    }

    function setSubmitting(on) {
      sending = on;
      submitBtn.disabled = on;
      submitBtn.innerHTML = on ? window.g26t('stores.reserve.sending', 'Wird gesendet …') : window.g26t('stores.preorder_reserve.submit', 'Reservierung anfragen');
    }

    // The message sits under the button, and on a phone the sheet is usually scrolled to the button
    // already, so a new message would land below the fold: bring it into view.
    function fail(code) {
      errEl.innerHTML = errorText(code);
      show(errEl, true);
      try { errEl.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }

    function resetForm() {
      show(form, true);
      show(intro, true);
      show(ctxEl, true);
      show(okEl, false);
      show(errEl, false);
      [storeSel, nameEl, mailEl].forEach(function (el) { el.removeAttribute('aria-invalid'); });
      setSubmitting(false);
    }

    // A Turnstile token is good for one request: a fresh one for every opening and after every refusal.
    function freshTurnstile() {
      token = '';
      if (widget !== null) { try { window.turnstile.reset(widget); } catch (e) {} return; }
      loadTurnstile().then(function (ts) {
        if (widget !== null) return;
        widget = ts.render(tsBox, {
          sitekey: config.sitekey,
          size: 'flexible',
          language: lang,
          action: 'preorder-reserve',
          callback: function (tok) { token = tok; },
          'expired-callback': function () { token = ''; },
          'error-callback': function () { token = ''; },
        });
      }).catch(function () { fail('turnstile'); });
    }

    // Submitting before Turnstile has answered just waits for it a few seconds.
    function waitForToken(ms) {
      return new Promise(function (resolve) {
        var until = Date.now() + ms;
        (function poll() {
          if (token) return resolve(token);
          if (Date.now() > until) return resolve('');
          setTimeout(poll, 200);
        })();
      });
    }

    function open() {
      if (!config) return;
      resetForm();
      fillContext();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      freshTurnstile();
      var first = !storeSel.value ? storeSel : (!nameEl.value ? nameEl : (!mailEl.value ? mailEl : submitBtn));
      try { first.focus(); } catch (e) {}
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function submit() {
      if (sending) return;
      show(errEl, false);
      var store = storeSel.value;
      var name = nameEl.value.trim();
      var email = mailEl.value.trim();
      storeSel.setAttribute('aria-invalid', store ? 'false' : 'true');
      nameEl.setAttribute('aria-invalid', name.length >= 2 ? 'false' : 'true');
      mailEl.setAttribute('aria-invalid', EMAIL_RE.test(email) ? 'false' : 'true');
      if (!store) return fail('store');
      if (name.length < 2) return fail('name');
      if (!EMAIL_RE.test(email)) return fail('email');
      var variant = variantId();
      if (!variant) return fail('unavailable');

      setSubmitting(true);
      waitForToken(8000).then(function (tok) {
        if (!tok) { setSubmitting(false); fail('turnstile'); return null; }
        return fetch(base + '/api/public/reserve', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify({ kind: 'preorder', location_id: store, variant_id: variant, name: name, email: email, lang: lang, turnstile: tok }),
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, body: j || {} }; }); })
          .then(function (res) {
            if (res.ok && res.body.ok) {
              okEl.innerHTML = window.g26t('stores.preorder_reserve.success', 'Fast geschafft: Bitte bestätigen Sie die Reservierung über den Link in der E-Mail an {{ email }}. Der Link gilt 48 Stunden.', { email: esc(email) });
              show(okEl, true);
              show(form, false);
              show(intro, false);
              show(ctxEl, false);
              sending = false;
              return;
            }
            setSubmitting(false);
            fail(res.body.code);
            freshTurnstile();
          });
      }).catch(function () {
        setSubmitting(false);
        fail(null);
        freshTurnstile();
      });
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-presv-close]'), function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    submitBtn.addEventListener('click', submit);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
